<template>
    <div class="form-horizontal">
        <input-text
            label="Name"
            field="name"
            v-model="form.name"
            :form="form"
        />
        <div class="form-group" v-if="uiType == 'provider'">
            <label>Assigned Location(s)</label>

            <multiselect
                placeholder="Search or add a location"
                track-by="id"
                label="name"
                :multiple="true"
                :taggable="true"
                :loading="loadingLocations"
                v-model="form.locations"
                :options="locations"
            />
        </div>
        <div class="form-row">
            <input-text
                class="col-md-6"
                label="Address"
                field="address"
                v-model="form.address"
                :form="form"
                @input="searchLocationWithGoogleMaps"
            />
            <div class="form-group col-md-6">
                <label for="region">Region</label>
                <tags
                    class="w-100"
                    id="region"
                    v-model="form.region"
                    placeholder=""
                    format="input"
                    tag-placeholder="Create new"
                    type="region"
                    :multiple="false"
                    :close-on-select="true"
                />
            </div>
        </div>
        <div class="form-group" v-if="has_results">
            <gmap-map
                class="map"
                :zoom="form.zoom"
                :center="position"
                @zoom_changed="onZoomChanged"
                :options="mapOptions">
                <gmap-marker
                    :position="position"
                    :clickable="true"
                    :draggable="true"
                    @dragend="onMarkerMoved"
                />
            </gmap-map>
        </div>
        <div class="form-row">
            <input-text
                class="col-md-5"
                label="Latitude"
                field="latitude"
                v-model.number="form.latitude"
                :form="form"
            />
            <input-text
                class="col-md-5"
                label="Longitude"
                field="longitude"
                v-model.number="form.longitude"
                :form="form"
            />
            <input-text
                class="col-md-2"
                type="number"
                label="Zoom"
                field="zoom"
                v-model.number="form.zoom"
                :form="form"
            />
        </div>
        <div v-if="location">
            <upload-image image-label="Default Location Image" v-model="form.image" :url="location.image" />
        </div>
        <div class="row">
            {{old_image_url}}
        </div>
        <div class="modal-footer mt-2 pr-0 pb-0 pl-0">
            <button class="btn btn-default" type="button" data-dismiss="modal">
                Close
            </button>
            <button-loading type="button" class="btn btn-primary ml-2"
                :loading="form.submitting"
                @click="save">
                Save
            </button-loading>
        </div>
    </div>
</template>

<script>
    import _ from "lodash";

    export default {

        props: {
            location: { type: Object },
            uiType: { type: String, in: ['location', 'provider'] }
        },

        data() {
            return {
                form: new Form(),
                mapOptions: {
                    mapTypeControl: false,
                    scrollWell: true,
                    gestureHandling: 'greedy'
                },
                has_results: false,
                locations  : [],
                loadingLocations: true,
                old_image_url: null
            }
        },

        watch: {
            location: {
                immediate: true,
                handler() {
                    if(this.location){
                        this.fetchLocations();
                    }

                    if (this.location && this.location.id) {
                        this.has_results = true;
                        this.form = new Form({
                            id: this.location.id,
                            name: this.location.name || '',
                            address: this.location.address || '',
                            region: this.location.region || {},
                            latitude: this.location.latitude,
                            longitude: this.location.longitude,
                            locations: this.location.locations,
                            zoom: this.location.zoom || 17,
                            type: this.location.uiType,
                            image: this.location.image || null
                        });

                        return;
                    }
                    this.has_results = false;
                    this.form = new Form({
                        id: null,
                        name: '',
                        address: '',
                        region: {},
                        latitude: null,
                        longitude: null,
                        locations: [],
                        zoom: 17,
                        type: this.uiType,
                        image: null
                    });
                }
            }
        },

        computed: {
            position() {
                return {
                    lat: this.form.latitude || null,
                    lng: this.form.longitude || null
                }
            },
        },

        methods: {
            onZoomChanged(zoom) {
                this.form.zoom = zoom;
            },

            onMarkerMoved(e) {
                this.form.latitude  = e.latLng.lat();
                this.form.longitude = e.latLng.lng();
            },

            searchLocationWithGoogleMaps: _.debounce(function () {
                if (!window.google) return;
                const geocoder = new google.maps.Geocoder;
                const address  = this.form.address;

                geocoder.geocode({address}, (results, status) => {
                    if (status !== 'OK') {
                        return;
                    }

                    this.has_results = true;
                    const location = results[0].geometry.location;
                    this.form.latitude = location.lat();
                    this.form.longitude = location.lng();
                })
            }, 500),

            async save() {
                if(this.uiType === 'provider'){

                    if(!this.form.address){
                        this.form.address = 'No Address';
                    }

                    if(!this.form.latitude){
                        this.form.latitude = 0.0;
                    }

                    if(!this.form.longitude){
                        this.form.longitude = 0.0;
                    }
                }

                const request = await this.form.id ? this.update() : this.create();
                return request.then(({data}) => {
                    this.$emit('save-location', data.id);
                    swal.fire({
                        title: 'Location Saved!',
                        type: 'success',
                    })
                })
                .catch(error => console.error(error));
            },

            update() {
                return this.form.put(this.$laroute.route('locations.update', {location: this.form.id}))
            },

            create() {
                return this.form.post(this.$laroute.route('locations.store'));
            },

            fetchLocations() {
                if(this.uiType == 'provider') {
                    this.$http.get(this.$laroute.route('api.locations.index'), {params: {type: "location"}})
                        .then(({data}) => {
                            this.locations = data.data;
                            this.loadingLocations = false;
                        });
                }
            },
        }
    }
</script>

<style lang="scss" scoped>
    .map {
        width: 100%;
        height: 300px;
        box-shadow: 0 1px 2px #dde4e7;
        border: 1px solid #ced4da;
        border-radius: 4px;
        overflow: hidden;
    }
</style>
